import { OverlayTrigger, Tooltip } from "react-bootstrap"
import ShimmerScreen from "../../../Layouts/ShimmerScreen"
import "./TitleTagsComponent.scss"
import { useEffect } from "react"

const TitleTagsComponent = ({ tagsArray, isLoading }) => {
    
    return (
        <>
            {tagsArray.length > 0 && (
                <OverlayTrigger
                    key='bottom'
                    placement='bottom'
                    overlay={
                        <Tooltip id={`tooltip-bottom`} className= 'title-overlay'>
                            <div
                                style={{
                                    color: "white",
                                    backgroundColor: "transparent",
                                }}

                            >
                                {
                                    tagsArray.map((t, i) => {
                                        return (
                                            <>
                                                <span dangerouslySetInnerHTML={{__html: t }}></span>
                                                {
                                                    (i != tagsArray.length - 1) ?
                                                    " | " : ""
                                                }
                                            </>
                                        )
                                        
                                    })
                                }
                               
                            </div>
                        </Tooltip>
                    }
                >
                    <ul className="cardlist-row">
                        {
                            tagsArray.map((t, i) => {
                                return (
                                    <li key={`index-${i + 1}`}>
                                        {
                                            isLoading
                                                ?
                                                <ShimmerScreen
                                                    case="rect"
                                                    width="2rem"
                                                    height="0.8rem"
                                                />
                                                :
                                                <span dangerouslySetInnerHTML={{__html: t }}></span>
                                        }
                                    </li>
                                )
                            })
                        }
                    </ul>
                </OverlayTrigger>
            )}
        </>

    )
}

export default TitleTagsComponent